export default __webpack_public_path__ + "static/media/imgSymboleLogo.e5010930.jpg";